import { QueryHookOptions, useQuery } from "@apollo/react-hooks";

import testCentres from "../graph-ql/testCentres.graphql";

const useQueryTestCentres = (opts?: QueryHookOptions) =>
  useQuery(testCentres, opts);

export default useQueryTestCentres;
